module.exports = "/assets/af953547db8f9e3b775f6470644142c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/PC.png
// module id = 2835
// module chunks = 0